import {
  createContext,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useContext,
  useState,
} from "react";
import type { IStoriesFolder } from "@/shared/types";

interface IMoveFolderCtx {
  folder: { name: string; _id: string };
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  setFolder: Dispatch<SetStateAction<{ name: string; _id: string }>>;
  closeDialog: () => void;
  folderId: string;
  folderData?: IStoriesFolder | undefined;
  folderName?: string | undefined;
}

const initState: IMoveFolderCtx = {
  folder: { name: "", _id: "" },
  loading: false,
  setLoading: () => {},
  setFolder: () => {},
  folderId: "",
  closeDialog: () => {},
};

const MoveFolderCtx = createContext<IMoveFolderCtx>(initState);

interface IProps {
  children: ReactNode;
  folderId: string;
  folderData?: IStoriesFolder;
  folderName?: string | undefined;
  closeDialog: () => void;
}

export const MoveFolderCtxProvider = ({
  children,
  folderId,
  folderData,
  folderName,
  closeDialog,
}: IProps) => {
  const [folder, setFolder] = useState<{ name: string; _id: string }>({
    name: "",
    _id: "",
  });
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <MoveFolderCtx.Provider
      value={{
        folder,
        loading,
        setLoading,
        setFolder,
        folderId,
        folderData,
        folderName,
        closeDialog,
      }}
    >
      {children}
    </MoveFolderCtx.Provider>
  );
};

export const useMoveFolderCtx = () => {
  const ctx = useContext(MoveFolderCtx);
  if (!ctx) {
    throw new Error(
      "useMoveFolderCtx must be used within a MoveFolderCtxProvider",
    );
  }
  return ctx;
};
